(function() {

    function funcReady() {
        $('.KRP0014').buildCommonUI();

        var KRP0014 = {
            init: function () {
                var self = this;

                self.setting();
                self.requestListData(this);

                self.$component.find('.faq-more-wrap').on('click', function() {
                    self.$component.find('.accordion-wrap > ul .lists').css('display', 'block');
                    $(this).hide();
                });
            },
            setting: function() {
                var self = this;

                self.$component = $('.component.KRP0014');
                self.listTemplate = '';
            },
            requestListData: function(el){
                var modelId = lgePdpSendData.modelId;
                if(modelId === "" || modelId === undefined) return;

                var ajaxUrl = this.$component.data('ajax') + modelId;
                var templateHtml = $("#faqContentTemplate").html();
                var param = {};

                if(this.$component.length === 0) return;
                if(ajaxUrl === "" || ajaxUrl === undefined) return;

                var dpType = 'PRODUCT';
                if(lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'careTab' || lgkorUI.parseUrl(location.href).searchParams.get("dpType") === 'upCareTab'){
                    dpType = 'CARESOLUTION'
                }
                param = {
                    bizType: dpType,
                };

                lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(ajaxUrl, param, function (result) {
                    if( result && result.status == '200') {
                        var resultData = result.data;
                        if (resultData.length > 0) {
                            resultData.forEach(function(item, index) {
                                if (templateHtml) {
                                    var populatedTemplate = templateHtml
                                        .replace('#title#', item.title)
                                        .replace('#content#', item.content);

                                    var $element = $(populatedTemplate);
                                    if (index > 9) {
                                        $element.css('display', 'none');
                                    }
                                    $('.component.KRP0014').find('.accordion-wrap > ul').append($element);
                                }
                            });
                            if(resultData.length < 11){
                                $('.component.KRP0014').find('.faq-more-wrap').hide();
                            }
                        }else {
                            $('.component.KRP0014').hide();
                        }
                    } else {
                        $('.component.KRP0014').hide();
                    }
                });
            }
        }
        KRP0014.init();
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'NOTICE', name: 'KRP0014', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0014')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0014')) return false;
        funcReady();
    });
})();
